import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demandsurvey-grid',
  templateUrl: './demandsurvey-grid.component.html',
  styleUrls: ['./demandsurvey-grid.component.css']
})
export class DemandsurveyGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landprocurement/demand-survey/demandsurvey-grid/demandsurvey-grid.component.ts